<template>
  <VContainer class="owerview-page">
    <VRow v-if="isLoading">
      <div class="d-flex flex-column align-center justify-center py-4 w-100">
        <VProgressCircular indeterminate color="primary" />
      </div>
    </VRow>
    <VRow v-else>
      <VCol cols="12">
        <div class="d-flex flex-column w-100 gap-28">
          <VRow>
            <VCol cols="12" sm="6">
              <div class="video-container">
                <a href="https://xtrapension.wistia.com/medias/6q1nubhj89?wvideo=6q1nubhj89" target="_blank"
                  ><img
                    src="https://embed-ssl.wistia.com/deliveries/3e4ec1d160cb6ce7796faa4612ae320a.jpg?image_play_button_size=2x&image_crop_resized=960x540&image_play_button_rounded=1&image_play_button_color=174bd2e0"
                    style="width: 400px; height: 225px"
                    width="400"
                    height="225"
                /></a>
                <div class="pension-container__title">Welcome to Pension Keeper</div>
              </div>
            </VCol>
            <VCol cols="12" sm="6">
              <div class="d-flex flex-column w-100 gap-28">
                <div class="pension-container">
                  <div class="pension-container__title">
                    Claim your UK pension from <span class="text-main-color">{{ owerviewData.pensionDate }}</span>
                  </div>
                  <div class="pension-container__text">(4 months before pension age)</div>
                  <div class="pension-container__age">
                    Your Pension age is <span class="text-main-color">{{ owerviewData.pensionAge }}</span>
                  </div>
                </div>
                <div class="card-container">
                  <div class="card-container__title">PENSION COUNTDOWN</div>
                  <div class="card-container__text">{{ owerviewData.timeRemaining }}</div>
                  <div>
                    <router-link :to="{ name: 'Contact Us' }" class="card-container__link"
                      >Claim Your Pension</router-link
                    >
                  </div>
                </div>
              </div>
            </VCol>
          </VRow>

          <div class="card-container">
            <div class="card-container__title">{{ owerviewData.taxYear }} Tax Year</div>
            <div class="card-container__text">You can pay this from {{ owerviewData.payFrom }}</div>
            <div class="card-container__btns">
              <div class="question">Did you pay?</div>
              <button
                :class="owerviewData.isPaid ? 'main-btn' : 'white-btn'"
                :disabled="isLoadingPay"
                @click="tickLastEntitlementOption()"
              >
                Yes
              </button>
              <button :class="owerviewData.isPaid ? 'white-btn' : 'main-btn'" :disabled="isLoadingPay">No</button>
            </div>
            <div>
              <router-link
                class="card-container__link"
                :to="{
                  name: 'How to Pay HMRC to Buy Another Year'
                }"
                >See How to Pay</router-link
              >
            </div>
          </div>
          <div class="hr"></div>
          <div class="help-btns-container">
            <div class="help-btns-container__title">What would you like to do next?</div>
            <div class="help-btns-container__btns">
              <button class="btn" @click="navigateTo('Check Your Entitlement')">Check your Entitlement</button>
              <button class="btn" @click="handleShowRequestCheckModal()">Check Payment Received</button>
              <button class="btn" @click="navigateTo('Contact Us')">Reapply Now</button>
            </div>
          </div>
          <div class="hr"></div>
          <Card class="w-100">
            <div class="latest-comments-container__title">Latest Communication from us</div>
            <div class="latest-comments-container__items">
              <div v-if="isLoadingComments" class="d-flex flex-column align-center justify-center py-4 w-100">
                <VProgressCircular indeterminate color="primary" />
              </div>
              <template v-else>
                <template v-if="comments.length">
                  <div
                    v-for="comment in comments"
                    :key="comment.subject"
                    @click="handleViewComment(comment)"
                    class="item"
                  >
                    <div class="d-flex gap-16">
                      <VIcon icon="mdi-email-outline" size="large"></VIcon>
                      <div class="item__title">{{ comment.subject }}</div>
                    </div>
                    <div class="item__date">{{ comment.createdDate }}</div>
                  </div>
                </template>
                <div v-else class="d-flex gap-10 my-3">
                  <VIcon icon="mdi-information-slab-circle-outline" size="24" color="primary"></VIcon>
                  <span>Latest Comments not found!</span>
                </div>
                <div>
                  <router-link :to="{ name: 'Latest Comments From Us' }" class="view-all-link">View All</router-link>
                </div>
              </template>
            </div>
          </Card>
          <Card class="w-100">
            <div class="your-documents-container__title">Your Documents</div>
            <div class="your-documents-container__items">
              <div v-if="isLoadingDocuments" class="d-flex flex-column align-center justify-center py-4 w-100">
                <VProgressCircular indeterminate color="primary" />
              </div>
              <template v-else>
                <template v-if="documents.length">
                  <div v-for="file in documents" :key="file.documentId" @click="handleViewDocument(file)" class="item">
                    <div class="d-flex gap-16">
                      <VIcon icon="mdi-file-document-multiple" size="large"></VIcon>
                      <div class="item__title">{{ file.documentTitle }}</div>
                    </div>

                    <div class="item__date">{{ file.createdDate }}</div>
                  </div>
                </template>
                <div v-else class="d-flex gap-10 my-3">
                  <VIcon icon="mdi-information-slab-circle-outline" size="24" color="primary"></VIcon>
                  <span>Documents not found!</span>
                </div>
                <div>
                  <router-link :to="{ name: 'Your Documents' }" class="view-all-link">View All</router-link>
                </div>
              </template>
            </div>
          </Card>
        </div>
      </VCol>
    </VRow>
  </VContainer>
  <ViewDocumentModal v-model="isShowViewDocumentModal" :documentId="documentId" />
  <ViewCommentModal v-model="isShowViewCommentModal" :commentId="commentId" />
  <RequestCheckModal v-model="isShowRequestCheckModal" :modalRequestCheckYears="modalRequestCheckYears" />
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
// Service
import documentsService from '@/services/documents-service/documents.service';
import applicationService from '@/services/application-service/application.service';
// Utils
import { formatLatestComments, formatDocuments, formatOwerviewData } from '@/utils/formatData';
// Components
import ViewDocumentModal from '@/components/modals/ViewDocumentModal/ViewDocumentModal.vue';
import ViewCommentModal from '@/components/modals/ViewCommentModal/ViewCommentModal.vue';
import RequestCheckModal from '@/components/modals/RequestCheckModal/RequestCheckModal.vue';
import Card from '@/components/common/Card/Card.vue';
export default {
  name: 'OverviewPage',
  components: {
    Card,
    ViewDocumentModal,
    ViewCommentModal,
    RequestCheckModal
  },
  computed: {
    ...mapGetters('user', ['userId'])
  },
  data() {
    return {
      isLoading: true,
      isLoadingComments: true,
      isShowViewCommentModal: false,
      commentId: null,
      isLoadingDocuments: true,
      isShowViewDocumentModal: false,
      documentId: null,
      isLoadingPay: false,
      owerviewData: {
        pensionDate: '',
        pensionAge: '',
        timeRemaining: '',
        payFrom: '',
        isPaid: false,
        taxYear: '',
        taxYearAllocation: []
      },
      isShowRequestCheckModal: false,
      modalRequestCheckYears: []
    };
  },
  mounted() {
    this.getOverview();
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    async getOverview() {
      this.isLoading = true;
      try {
        const { overview } = await applicationService.getOverview();
        this.owerviewData = formatOwerviewData(overview);
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      } finally {
        this.isLoading = false;
        this.getLatestComments();
        this.getDocuments();
      }
    },
    async tickLastEntitlementOption() {
      this.isLoadingPay = true;
      try {
        await applicationService.tickLastEntitlementOption();
        this.owerviewData.isPaid = true;
        this.navigateTo('Check Your Entitlement');
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      } finally {
        this.isLoadingPay = false;
      }
    },
    // View Comment
    async getLatestComments() {
      this.isLoadingComments = true;
      try {
        const { comments } = await applicationService.getLatestComments({ commentsLimit: 5 });
        this.comments = formatLatestComments(comments ?? []);
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      } finally {
        this.isLoadingComments = false;
      }
    },
    handleViewComment(item) {
      if (!item?.commentId) {
        return;
      }
      this.isShowViewCommentModal = true;
      this.commentId = item.commentId;
    },
    // View Document
    async getDocuments() {
      this.isLoadingDocuments = true;
      try {
        const { documents } = await documentsService.getDocuments({ recordId: this.userId, docLimit: 5 });
        this.documents = formatDocuments(documents ?? []);
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
      } finally {
        this.isLoadingDocuments = false;
      }
    },
    handleViewDocument(item) {
      if (!item?.documentId) {
        return;
      }
      this.isShowViewDocumentModal = true;
      this.documentId = item.documentId;
    },
    navigateTo(pageName) {
      if (!pageName) {
        return;
      }
      this.$router.push({ name: pageName });
    },
    handleShowRequestCheckModal() {
      this.isShowRequestCheckModal = true;
      this.modalRequestCheckYears = this.owerviewData.taxYearAllocation ?? [];
    }
  }
};
</script>
